import { useAccountStore } from '@/stores/account'
import { session } from '@/helpers/auth'
import { logger } from '@/shared/common/utils/logger.util'

/**
 * Dispara la carga del ejecutivo sin esperarla: la navegación no depende de esos datos
 * (los consume `ExecutiveContactButton`, reactivo al store) y el endpoint puede tardar
 * segundos o responder 404, lo que dejaba la pantalla en blanco.
 */
export async function setExecutiveData(): Promise<boolean> {
  if (!session()) return true

  const storeAccount = useAccountStore()

  if (storeAccount.executiveDataFetched) return true

  storeAccount.setExecutiveData().catch((error: unknown) => {
    logger.error(
      '[setExecutiveData] Error al cargar los datos del ejecutivo',
      {},
      error instanceof Error ? error : undefined
    )
  })
  return true
}
